import React, { useState, useEffect } from "react";
import instance from "../../instance";
import "../Customer.css";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ServerDetails = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("code");

  const [serverData, setServerData] = useState(null);
  const [isEditingServer, setIsEditingServer] = useState(false);

  const [serverFormData, setServerFormData] = useState({
    server: "",
    site: "",
    serverlocation: "",
    nameserver: "",
    status: "",
    type: "",
    ip: "",
    ipVpn: "",
  });

  useEffect(() => {
    if (code) {
      fetchServerData();
    } else {
      toast.error("No code provided.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetchServerData is recreated each render; adding it would refetch on every paint
  }, [code]);

  const fetchServerData = async () => {
    try {
      const response = await instance.get(`server/by-code/${code}`);

      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = response.data;
      if (data && data.data) {
        setServerData(data.data);
        setServerFormData({
          server: data.data.ServerStatus || "",
          site: data.data.ManagementSite || "",
          serverlocation: data.data.ServerLocation || "",
          nameserver: data.data.NameServer || "",
          status: data.data.Status || "",
          type: data.data.ServerType || "",
          ip: data.data.IP || "",
          ipVpn: data.data.IPVPN || "",
        });
      } else {
        toast.error("No server data found for the given code.");
      }
    } catch (error) {
      console.error("Error fetching server data:", error);
      toast.error("An error occurred while fetching server data.");
    }
  };

  const toggleEditServer = () => {
    if (isEditingServer) {
      saveServerData();
    } else {
      setIsEditingServer(!isEditingServer);
    }
  };

  const handleServerInputChange = (event) => {
    const { name, value } = event.target;
    setServerFormData({ ...serverFormData, [name]: value });
  };

  const saveServerData = async () => {
    const code = serverData.Code;

    try {
      const response = await instance.put(
        `server/by-code/${code}`,
        serverFormData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      toast.success("Server Details updated successfully!");
      fetchServerData(); // Fetch updated data instead of reloading the page
      setIsEditingServer(false); // Exit editing mode
    } catch (error) {
      console.error("Error updating server details:", error);
      toast.error("An error occurred while updating server details.");
    }
  };

  return (
    <div>
      <main>
        <section id="server-section">
          <h2>Server Details</h2>
          {serverData && (
            <ul>
              <li>
                Server:{" "}
                <span
                  className={`info ${isEditingServer ? "hidden" : ""}`}
                  id="info-server"
                  style={{
                    backgroundColor:
                      serverData.ServerStatus === "New"
                        ? "rgba(255, 255, 0, 0.2)"
                        : serverData.ServerStatus === "Active"
                        ? "rgba(28, 202, 28, 0.2)"
                        : serverData.ServerStatus === "Suspended"
                        ? "rgba(255, 0, 0, 0.2)"
                        : "transparent",
                  }}
                >
                  {serverData.ServerStatus}
                </span>
                {isEditingServer && (
                  <select
                    className="input-field"
                    name="server"
                    value={serverFormData.server}
                    onChange={handleServerInputChange}
                  >
                    <option value="New">New</option>
                    <option value="Active">Active</option>
                    <option value="Suspended">Suspended</option>
                  </select>
                )}
              </li>
              <li>
                Management Site:{" "}
                <span
                  className={`info ${isEditingServer ? "hidden" : ""}`}
                  id="info-site"
                >
                  <a
                    href={serverData.ManagementSite}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {serverData.ManagementSite}
                  </a>
                </span>
                {isEditingServer && (
                  <input
                    className="input-field"
                    type="text"
                    name="site"
                    value={serverFormData.site}
                    onChange={handleServerInputChange}
                    placeholder="Enter the website of the service provided"
                  />
                )}
              </li>
              <li>
                Server Location:{" "}
                <span
                  className={`info ${isEditingServer ? "hidden" : ""}`}
                  id="info-serverlocation"
                >
                  {serverData.ServerLocation}
                </span>
                {isEditingServer && (
                  <input
                    className="input-field"
                    type="text"
                    name="serverlocation"
                    value={serverFormData.serverlocation}
                    onChange={handleServerInputChange}
                    placeholder="Enter the server location"
                  />
                )}
              </li>
              <li>
                Name Server:{" "}
                <span
                  className={`info ${isEditingServer ? "hidden" : ""}`}
                  id="info-nameserver"
                >
                  {serverData.NameServer}
                </span>
                {isEditingServer && (
                  <input
                    className="input-field"
                    type="text"
                    name="nameserver"
                    value={serverFormData.nameserver}
                    onChange={handleServerInputChange}
                    placeholder="Enter the server name"
                  />
                )}
              </li>
              <li>
                Status:{" "}
                <span
                  className={`info ${isEditingServer ? "hidden" : ""}`}
                  id="info-status"
                  style={{
                    backgroundColor:
                      serverData.Status === "Offline"
                        ? "rgba(4, 157, 246, 0.2)"
                        : serverData.Status === "Online"
                        ? "rgba(28, 202, 28, 0.2)"
                        : serverData.Status === "Maintenance"
                        ? "rgba(255, 255, 0, 0.2)"
                        : "transparent",
                  }}
                >
                  {serverData.Status}
                </span>
                {isEditingServer && (
                  <select
                    className="input-field"
                    name="status"
                    value={serverFormData.status}
                    onChange={handleServerInputChange}
                  >
                    <option value="Online">Online</option>
                    <option value="Offline">Offline</option>
                    <option value="Maintenance">Maintenance</option>
                  </select>
                )}
              </li>
              <li>
                Type:{" "}
                <span
                  className={`info ${isEditingServer ? "hidden" : ""}`}
                  id="info-type"
                >
                  {serverData.ServerType}
                </span>
                {isEditingServer && (
                  <select
                    className="input-field"
                    name="type"
                    placeholder="Enter server type"
                    value={serverFormData.type}
                    onChange={handleServerInputChange}
                  >
                    <option value="Web Hosting">Web Hosting</option>
                    <option value="Virtual Private Server Hosting">
                      Virtual Private Server Hosting
                    </option>
                    <option selected value="Dedicated Server Hosting">
                      Dedicated Server Hosting
                    </option>
                    <option value="Managed Hosting">Managed Hosting</option>
                    <option value="Cloud Hosting">Cloud Hosting</option>
                  </select>
                )}
              </li>
              <li>
                Ip:{" "}
                <span
                  className={`info ${isEditingServer ? "hidden" : ""}`}
                  id="info-ip"
                >
                  {serverData.IP}
                </span>
                {isEditingServer && (
                  <input
                    className="input-field"
                    type="text"
                    name="ip"
                    value={serverFormData.ip}
                    onChange={handleServerInputChange}
                    placeholder="Enter the server IP"
                  />
                )}
              </li>
              <li>
                Ip Vpn:{" "}
                <span
                  className={`info ${isEditingServer ? "hidden" : ""}`}
                  id="info-ipVpn"
                >
                  {serverData.IPVPN}
                </span>
                {isEditingServer && (
                  <input
                    className="input-field"
                    type="text"
                    name="ipVpn"
                    value={serverFormData.ipVpn}
                    onChange={handleServerInputChange}
                    placeholder="Enter the server IP Vpn"
                  />
                )}
              </li>
            </ul>
          )}
          <button className="edit-button" onClick={toggleEditServer}>
            {isEditingServer ? "Save" : "Update"}
          </button>
        </section>
      </main>
    </div>
  );
};

export default ServerDetails;
